fx.ns("shared.components", class CoverThumbPhoto extends shared.components.CoverThumb 
{    
    constructor(parameters)
    {
        super(parameters);
    }

    load()
    {
        super.load();
        
        if (this.data instanceof models.ThemeLayoutComponent)
        {
            this.loadImage(fx.assets.layoutPlaceHolder.content);
        }
        else
        {
            var photo = this.model.photos.find({id: this.data.content});

            if (!photo || photo.deleted)
                this.ready();
            else
                this.loadImage(photo.light_url);
        }
    }

    onImageLoaded()
    {
        this._tmpCanvas = document.createElement('canvas');
        this._tmpCanvas.width = this.elementWidth;
        this._tmpCanvas.height = this.elementHeight;
        this._tmpcontext = this._tmpCanvas.getContext('2d');

        this._tmpImgcanvas = document.createElement('canvas');
        
        if (this.elementRotationInner == 0 || this.elementRotationInner == 180)
        {
            this._tmpImgcanvas.width = this.image.width;
            this._tmpImgcanvas.height = this.image.height;
        }
        else
        {
            this._tmpImgcanvas.width = this.image.height;
            this._tmpImgcanvas.height = this.image.width;
        }

        var imgcontext = this._tmpImgcanvas.getContext('2d');
        this._tmpcontext.translate(this._tmpImgcanvas.width/2, this._tmpImgcanvas.height/2);
        imgcontext.rotate(this.elementRotationInner*this.TO_RADIANS);

        if (this.elementRotationInner == 0)
            imgcontext.drawImage(this.image, 0, 0, this.image.width, this.image.height);
        else
        if (this.elementRotationInner == 90)
            imgcontext.drawImage(this.image, 0, -this.image.height, this.image.width, this.image.height);
        else
        if (this.elementRotationInner == 180)
            imgcontext.drawImage(this.image, -this.image.width, -this.image.height, this.image.width, this.image.height);
        else
        if (this.elementRotationInner == 270)
            imgcontext.drawImage(this.image, -this.image.width, 0, this.image.width, this.image.height);
    
        imgcontext.rotate(-this.elementRotationInner*this.TO_RADIANS);
        this._tmpcontext.translate(-this._tmpImgcanvas.width/2, -this._tmpImgcanvas.height/2);
        
        let mask = this.model.masks.find({id: this.data.photomask});
        let maskURL = mask ? mask.thumb : null;
        if (maskURL)
        {
            this._maskimg = new Image();
            this.on("load", this._onMaskDrawn, this._maskimg );
            this.on("error", this._onMaskDrawn, this._maskimg);    
            this._maskimg.src = maskURL;   
        }
        else
            this._onMaskDrawn(false);
    }

    _onMaskDrawn(event) 
    {
        if(event === true || event.type == "load") 
        {
            this._tmpcontext.drawImage(this._maskimg, 0, 0, this._tmpCanvas.width,  this._tmpCanvas.height);
            this._tmpcontext.globalCompositeOperation = 'source-in';
        }

        switch(this.elementRotationInner)
        {
            case 0 :
                this._tmpcontext.drawImage(this._tmpImgcanvas, this.elementXInner, this.elementYInner, this.elementWidthInner, this.elementHeightInner);
            break;

            case 90 :
                this._tmpcontext.drawImage(this._tmpImgcanvas,  this.elementXInner, this.elementYInner, this.elementHeightInner, this.elementWidthInner);
            break;

            case 180 :
                this._tmpcontext.drawImage(this._tmpImgcanvas,  0, 0, this._tmpImgcanvas.width, this._tmpImgcanvas.height, this.elementXInner, this.elementYInner, this.elementWidthInner, this.elementHeightInner);
            break;

            case 270 :
                this._tmpcontext.drawImage(this._tmpImgcanvas, this.elementXInner, this.elementYInner, this.elementHeightInner, this.elementWidthInner);
            break;
        }

        this.context.save();
        this.context.translate(this.elementX-this.offset, this.elementY);
        this.context.rotate(this.elementRotation*this.TO_RADIANS);
        this.context.translate(-(this.elementX-this.offset), -this.elementY);
        this.context.drawImage(this._tmpCanvas, this.elementX-this.offset, this.elementY-1, this._tmpCanvas.width+1, this._tmpCanvas.height+1);
        
        if(this.data.borderid>0)
        {
            this.context.lineWidth = this.data.borderid * this.creationSize.ratio;
            this.context.strokeStyle = this.data.side;
            this.context.strokeRect(this.elementX-this.offset-parseInt(this.data.borderid)/2, this.elementY-parseInt(this.data.borderid)/2, this._tmpCanvas.width+parseInt(this.data.borderid), this._tmpCanvas.height+parseInt(this.data.borderid));//for white background
        }

        this.context.restore();

        this._tmpImgcanvas = null;
        this._tmpcontext = null;
        this._tmpCanvas = null;

        this.ready();
    }
});
